import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import {CheckCircle} from 'lucide-react';

const PaymentSuccessPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [lang, setLang] = useState('zh');

  // 從 URL 讀取參數
  const checkoutId = searchParams.get('checkout_id') || searchParams.get('session_id');
  const orderId = searchParams.get('order_id');

  useEffect(() => {
    // 檢測語言
    const path = location.pathname;
    if (path.startsWith('/en')) {
      setLang('en');
    }
  }, [location.pathname]);

  const content = {
    zh: {
      title: '付款成功',
      subtitle: '感謝您的購買！',
      checkoutId: 'Checkout ID',
      orderId: '訂單編號',
      message: '您的訂單已成功處理，我們將盡快為您準備商品。',
      backButton: '返回首頁',
      orderButton: '查看訂單'
    },
    en: {
      title: 'Payment Successful',
      subtitle: 'Thank you for your purchase!',
      checkoutId: 'Checkout ID',
      orderId: 'Order ID',
      message: 'Your order has been successfully processed. We will prepare your items soon.',
      backButton: 'Back to Home',
      orderButton: 'View Orders'
    }
  };

  const t = content[lang as keyof typeof content];

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-4 py-12">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 text-center">
        {/* 成功圖示 */}
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center">
            <CheckCircle className="w-10 h-10 text-green-600 dark:text-green-400" />
          </div>
        </div>

        {/* 標題 */}
        <h1 className="text-3xl font-light text-gray-900 dark:text-white mb-2">
          {t.title}
        </h1>
        <p className="text-lg text-gray-600 dark:text-gray-400 mb-6">
          {t.subtitle}
        </p>

        {/* 訂單資訊 */}
        <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4 mb-6 text-left space-y-2">
          {checkoutId && (
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600 dark:text-gray-400">{t.checkoutId}:</span>
              <span className="text-sm font-mono text-gray-900 dark:text-white">{checkoutId}</span>
            </div>
          )}
          {orderId && (
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600 dark:text-gray-400">{t.orderId}:</span>
              <span className="text-sm font-mono text-gray-900 dark:text-white">{orderId}</span>
            </div>
          )}
        </div>

        {/* 訊息 */}
        <p className="text-gray-600 dark:text-gray-400 mb-8">
          {t.message}
        </p>

        {/* 按鈕 */}
        <div className="space-y-3">
          <button
            onClick={() => navigate(`/${lang}/member`)}
            className="w-full bg-black dark:bg-white text-white dark:text-black py-3 rounded-lg hover:bg-gray-800 dark:hover:bg-gray-100 transition-colors"
          >
            {t.orderButton}
          </button>
          <button
            onClick={() => navigate(`/${lang}`)}
            className="w-full border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 py-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
          >
            {t.backButton}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
